// #2121-spec-kits
import React from 'react';
import { Input, Badge } from 'reactstrap';
import { translate } from 'react-translate';
import { useDraggable } from '@dnd-kit/core';

const ASSET_ICON = {
  cellphone:  'now-ui-icons tech_mobile',
  device:     'now-ui-icons objects_diamond',
  'sim card': 'now-ui-icons tech_tv',
};

// Card visual reusable: en la lista (Draggable) y dentro del DragOverlay.
export const AssetCard = ({ asset, isOverlay = false, isDragging = false }) => {
  const icon = ASSET_ICON[asset.asset_type] || 'now-ui-icons objects_diamond';
  const cls = [
    'draggable-asset',
    isOverlay ? 'is-overlay' : '',
    isDragging ? 'is-dragging-source' : '',
  ].filter(Boolean).join(' ');
  return (
    <div className={cls}>
      <div className={`asset-icon ${icon}`} />
      <div className="asset-body">
        <div className="asset-type">{asset.asset_type || '—'}</div>
        <div className="asset-meta">
          {asset.brand && (
            <>
              <span className="asset-meta-key">{asset.brand}</span>
            </>
          )}
          {asset.model && (
            <>
              <span> · </span>
              <span className="asset-meta-key">{asset.model}</span>
            </>
          )}
          <br/>
          {asset.identifier && (
            <>
              <span className="asset-meta-key">{asset.identifier}</span>
              <span> · </span>
            </>
          )}
          <span className="asset-meta-val">{asset.serial_number || asset._id}</span>
        </div>
      </div>
      <i className="drag-handle now-ui-icons design_bullet-list-67" />
    </div>
  );
};

const Draggable = ({ id, asset, isDragging }) => {
  const { attributes, listeners, setNodeRef } = useDraggable({ id });
  // No aplicamos transform: el DragOverlay renderiza el preview en un portal,
  // así escapa el overflow:auto del scroll container.
  return (
    <div ref={setNodeRef} {...listeners} {...attributes}>
      <AssetCard asset={asset} isDragging={isDragging} />
    </div>
  );
};

const AvailableAssetDraggable = (props) => {
  const { t, draggableIDPrefix, changeDataSearch, data, page, totalPage, activeId } = props;

  const onSearchChange = (e) => {
    const val = e.target.value || null;
    changeDataSearch(0, val);
  };

  return (
    <div className="kit-dnd-col">
      <div className="kit-form-card-header">
        <i className="now-ui-icons shopping_box" />
        <span>{t('available-assets')}</span>
        <Badge className="kit-form-card-count" pill>
          {data ? data.length : 0}
        </Badge>
      </div>

      <div className="kit-dnd-search">
        <Input
          type="text"
          placeholder={t('search-text-logList')}
          onChange={onSearchChange}
        />
      </div>

      <div className="kit-dnd-list">
        {data && data.length ? (
          data.map((a) => (
            <Draggable
              key={`${draggableIDPrefix}${a._id}`}
              id={`${draggableIDPrefix}${a._id}`}
              asset={a}
              isDragging={activeId === a._id}
            />
          ))
        ) : (
          <div className="text-center py-4 text-muted" style={{ fontStyle: 'italic' }}>
            {t('no-available-assets')}
          </div>
        )}
      </div>

      <div className="kit-pager">
        <button
          type="button"
          className="kit-pager-btn"
          disabled={page === 0}
          onClick={(e) => { e.preventDefault(); changeDataSearch(page - 1); }}
          aria-label="Previous page"
        >
          <i className="now-ui-icons arrows-1_minimal-left" />
        </button>
        <span className="kit-pager-info">
          {t('page')} {page + 1} / {totalPage || 1}
        </span>
        <button
          type="button"
          className="kit-pager-btn"
          disabled={page + 1 >= totalPage}
          onClick={(e) => { e.preventDefault(); changeDataSearch(page + 1); }}
          aria-label="Next page"
        >
          <i className="now-ui-icons arrows-1_minimal-right" />
        </button>
      </div>
    </div>
  );
};

export default translate('kits')(AvailableAssetDraggable);
